/**
 * Build a capture for the coop's `pages/` folder (formerly `eggs/`), in the
 * same shape the desktop writes (`paste-source`): minimal YAML frontmatter +
 * the text. The desktop's Hatch scans `pages/` by content, not filename, so
 * the backend's `pages/<ts>-<slug>.md` naming is fine — this just needs the
 * frontmatter right.
 */
import { slugify } from '../shared/slug.js';

export interface Egg {
  /** Filename stem for the upload (`pages/<ts>-<slug>.md`). */
  slug: string;
  /** Frontmatter + body — what gets written to Dropbox. */
  content: string;
  /** First line, for display in the queue. */
  title: string;
}

/** A filename slug from a capture's text — its first non-blank line, trimmed. */
export function eggSlug(text: string): string {
  const firstLine = text.split('\n').find((l) => l.trim()) ?? '';
  return slugify(firstLine).slice(0, 60) || 'note';
}

export function buildEgg(text: string, now: Date = new Date()): Egg {
  const trimmed = text.trim();
  const lines = trimmed.split('\n');
  const title = (lines.find((l) => l.trim()) ?? 'note').trim();

  const afterTitle = trimmed.slice(trimmed.indexOf(title) + title.length).trim();
  const body = afterTitle || title;

  const content =
    `---\n` +
    `title: ${title.replace(/\s+/g, ' ')}\n` +
    `added: ${now.toISOString()}\n` +
    `source: kip-pwa\n` +
    `---\n\n` +
    `${body}\n`;

  return { slug: eggSlug(title), content, title };
}
